import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  opening: {
    id: 'app.components.FilterDropdown.opening',
    defaultMessage:
      '{count, plural,=0 {All Openings} one {# Opening} other {# Openings}}',
  },
  openingOwner: {
    id: 'app.components.FilterDropdown.openingOwner',
    defaultMessage:
      '{count, plural,=0 {All Opening Owners} one {# Opening Owner} other {# Opening Owners}}',
    description:
      'Button label/selected count for the Opening Owner filter dropdown (owners of openings)',
  },
  stage: {
    id: 'app.components.FilterDropdown.stage',
    defaultMessage:
      '{count, plural,=0 {All Stages} one {# Stage} other {# Stages}}',
  },
  locationGroup: {
    id: 'app.components.FilterDropdown.locationGroup',
    defaultMessage:
      '{count, plural,=0 {All Location Groups} one {# Location Group} other {# Location Groups}}',
  },
  position: {
    id: 'app.components.FilterDropdown.position',
    defaultMessage:
      '{count, plural,=0 {All Positions} one {# Position} other {# Positions}}',
  },
  location: {
    id: 'app.components.FilterDropdown.location',
    defaultMessage:
      '{count, plural,=0 {All Locations} one {# Location} other {# Locations}}',
  },
  searchPlaceholder: {
    id: 'app.components.FilterDropdown.searchOpenings',
    defaultMessage: 'Search {name}s',
  },
  clearAll: {
    id: 'app.components.FilterDropdown.clearAll',
    defaultMessage: 'Clear all',
  },
});
